import {AnimationLoadingScreen} from '../../../components/loading/loadingScreen';
import {VerifyPhoneNumberPage} from './verifyPhone.components';
import {useUserDataFetcher, useVerificationLogic} from './verifyPhone.hooks';

/**
 * Renders a component for verifying a user's phone number.
 *
 * @returns {JSX.Element|string} - The rendered component or an "Unauthorized" message.
 * @throws {Error} - If there is an error during the verification process.
 */
export const VerifyPhonePage = () => {
  const {email, maskedPhoneNumber} = useUserDataFetcher();
  const {
    code,
    setCode,
    incorrect,
    isLoading,
    handleTextSend,
    handleTextVerify,
    sendNewCodeActivated,
    skipPhoneVerification,
  } = useVerificationLogic(email, maskedPhoneNumber);

  return isLoading ? (
    <AnimationLoadingScreen />
  ) : maskedPhoneNumber !== '' ? (
    <VerifyPhoneNumberPage
      code={code}
      setCode={setCode}
      incorrect={incorrect}
      handleTextSend={handleTextSend}
      handleTextVerify={handleTextVerify}
      maskedPhoneNumber={maskedPhoneNumber}
      sendNewCodeActivated={sendNewCodeActivated}
      skipPhoneVerification={skipPhoneVerification}
    />
  ) : (
    'Unauthorized.'
  );
};
